import { useEffect } from "react";

const useNotificationListener = () => {

    useEffect(() => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.addEventListener("message", (event) => {
                if (event.data?.type === "LOGOUT_USER") {
                    console.log("Logging out user due to role permissions update.");

                    // Clear localStorage
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");

                    // Redirect to sign-in page
                    window.location.replace('/sign-in');
                }
            });
        }
    }, []);
};

export default useNotificationListener;
